import { useSelector } from 'react-redux'

import { getInitialValues, getFormConfig, getUserDetails, getIsValidSession } from '../store/modules/newReport/selectors'

/**
 * @description returns new form config
 * @returns
 */
export const useFormConfig = ({ reportId }) => {
  return useSelector(getFormConfig({ reportId }))
}

/**
 * @description returns initial values for use in form
 * @returns
 */
export const useInitialValues = ({ reportId }) => {
  return useSelector(getInitialValues({ reportId }))
}

/**
 * @description returns user details for use in form
 * @returns
 */
export const useUserDetails = ({ reportId }) => {
  return useSelector(getUserDetails({ reportId }))
}

/**
 * @description returns user details for use in form
 * @returns
 */
export const useIsValidSession = ({ reportId }) => {
  return useSelector(getIsValidSession({ reportId }))
}
